import { render } from "./PopUpForm.vue?vue&type=template&id=11d586de&scoped=true"
import script from "./PopUpForm.vue?vue&type=script&lang=js"
export * from "./PopUpForm.vue?vue&type=script&lang=js"

import "./PopUpForm.vue?vue&type=style&index=0&id=11d586de&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d586de"]])

export default __exports__